// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"39":"help","330":"profile-edit","784":"stats"}[chunkId] + "." + {"39":"8e86454e","330":"484e0d5e","784":"229c5c33"}[chunkId] + ".css";
};